/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_Region_9Inputs */

const en_live_caption_youtube_region_9 = /** @type {(inputs: Live_Caption_Youtube_Region_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bottom right`)
};

const fr_live_caption_youtube_region_9 = /** @type {(inputs: Live_Caption_Youtube_Region_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En bas à droite`)
};

const de_live_caption_youtube_region_9 = /** @type {(inputs: Live_Caption_Youtube_Region_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unten rechts`)
};

const it_live_caption_youtube_region_9 = /** @type {(inputs: Live_Caption_Youtube_Region_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In basso o`)
};

const ru_live_caption_youtube_region_9 = /** @type {(inputs: Live_Caption_Youtube_Region_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Внизу справа`)
};

const es_live_caption_youtube_region_9 = /** @type {(inputs: Live_Caption_Youtube_Region_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abajo a la derecha`)
};

const zh_cn2_live_caption_youtube_region_9 = /** @type {(inputs: Live_Caption_Youtube_Region_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右下角`)
};

const ja_live_caption_youtube_region_9 = /** @type {(inputs: Live_Caption_Youtube_Region_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右下`)
};

const hi_live_caption_youtube_region_9 = /** @type {(inputs: Live_Caption_Youtube_Region_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नीचे दाएं`)
};

const pt_pt2_live_caption_youtube_region_9 = /** @type {(inputs: Live_Caption_Youtube_Region_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canto inferior direito`)
};

/**
* | output |
* | --- |
* | "Bottom right" |
*
* @param {Live_Caption_Youtube_Region_9Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_region_9 = /** @type {((inputs?: Live_Caption_Youtube_Region_9Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_Region_9Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_youtube_region_9(inputs)
	if (locale === "de") return de_live_caption_youtube_region_9(inputs)
	if (locale === "it") return it_live_caption_youtube_region_9(inputs)
	if (locale === "ru") return ru_live_caption_youtube_region_9(inputs)
	if (locale === "es") return es_live_caption_youtube_region_9(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_youtube_region_9(inputs)
	if (locale === "ja") return ja_live_caption_youtube_region_9(inputs)
	if (locale === "hi") return hi_live_caption_youtube_region_9(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_youtube_region_9(inputs)
	return en_live_caption_youtube_region_9(inputs)
});